import * as React from 'react';
import { NativeEventSource, EventSourcePolyfill } from 'event-source-polyfill';
import { withDataFetchNivo } from '../hoc/withDataFetchNivo';
const EventSource = NativeEventSource || EventSourcePolyfill;

const ResponsiveScatterPlot = React.lazy(() =>
  import('@nivo/scatterplot').then(module => ({
    default: module.ResponsiveScatterPlot,
  }))
);

const ScatterPlotWidget: React.FC<any> = ({ data, sseUrl }) => {
  const { margin, xScale, yScale, axisBottom, axisLeft, legends } = data.view;
  const [renderData, setRenderData] = React.useState(data.data);

  React.useEffect(() => {
    if (typeof sseUrl === 'undefined') return;
    const events = new EventSource(sseUrl);
    events.onmessage = (event: any) => updateRenderData(JSON.parse(event.data));

    return () => {
      if (events) {
        events.close();
      }
    };
  }, [sseUrl]);

  const updateRenderData = (data: any) => {
    setRenderData(data);
  };

  React.useEffect(() => {
    setRenderData(data.data);
  }, [data]);

  return (
    <React.Suspense fallback="loading...">
      <ResponsiveScatterPlot
        data={renderData}
        margin={margin}
        xScale={xScale}
        xFormat={function(e) {
          return e + ' kg';
        }}
        yScale={yScale}
        yFormat={function(e) {
          return e + ' cm';
        }}
        blendMode="multiply"
        axisTop={null}
        axisRight={null}
        axisBottom={axisBottom}
        axisLeft={axisLeft}
        legends={legends}
      />
    </React.Suspense>
  );
};

export default withDataFetchNivo(ScatterPlotWidget);
